import { render, staticRenderFns } from "./HowtoBackground.vue?vue&type=template&id=5effb1b9&scoped=true&"
import script from "./HowtoBackground.vue?vue&type=script&lang=js&"
export * from "./HowtoBackground.vue?vue&type=script&lang=js&"
import style0 from "./HowtoBackground.vue?vue&type=style&index=0&id=5effb1b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5effb1b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5effb1b9')) {
      api.createRecord('5effb1b9', component.options)
    } else {
      api.reload('5effb1b9', component.options)
    }
    module.hot.accept("./HowtoBackground.vue?vue&type=template&id=5effb1b9&scoped=true&", function () {
      api.rerender('5effb1b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/HowtoBackground.vue"
export default component.exports